export default __webpack_public_path__ + "static/media/comparison-nova.bfddd37d.jpg";